import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { SystemRedFlag } from '../../enums/red-flag.enum';
import { RedFlag } from '../../interfaces/red-flag';
import * as CompanyRedFlagsActions from './company-red-flags.actions';

export const companyRedFlagsFeatureKey = 'company-red-flags';

export interface State {
  items: RedFlag[];
  loading: boolean;
  error: unknown | null;
  /** Mind. ein Katalog-Ladevorgang abgeschlossen (Erfolg oder Fehler). */
  catalogFetched: boolean;
}

export const initialState: State = {
  items: [],
  loading: false,
  error: null,
  catalogFetched: false,
};

export const companyRedFlagsReducer = createReducer(
  initialState,
  on(CompanyRedFlagsActions.loadCompanyRedFlags, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(CompanyRedFlagsActions.loadCompanyRedFlagsSuccess, (state, action) => ({
    ...state,
    items: [...action.redFlags]
      .map((r) => ({ ...r, edited: r.edited === true }))
      .sort((a, b) => (b.creationTime ?? '').localeCompare(a.creationTime ?? '')),
    loading: false,
    catalogFetched: true,
  })),
  on(CompanyRedFlagsActions.loadCompanyRedFlagsFailure, (state, action) => ({
    ...state,
    error: action.error,
    loading: false,
    catalogFetched: true,
  }))
);

export const selectCompanyRedFlagsState = createFeatureSelector<State>(companyRedFlagsFeatureKey);

export const selectCompanyRedFlagsAll = createSelector(
  selectCompanyRedFlagsState,
  (state) => state.items
);

/** Lookup `id` → Eintrag (Katalog + Overlays). */
export const selectCompanyRedFlagsByIdMap = createSelector(
  selectCompanyRedFlagsAll,
  (items): ReadonlyMap<number, RedFlag> => {
    const map = new Map<number, RedFlag>();
    for (const f of items) {
      if (f.id != null) {
        map.set(f.id, f);
      }
    }
    return map;
  }
);

/** Nur Unternehmens-Katalog (`edited === false`), z. B. Bibliothek im Job-Editor. */
export const selectCompanyRedFlagsLibrary = createSelector(
  selectCompanyRedFlagsAll,
  (items) =>
    items.filter(
      (f) =>
        f.edited === false &&
        f.systemRedFlag !== SystemRedFlag.MINIMAL_LACKING_KO_SKILLS &&
        f.systemRedFlag !== SystemRedFlag.LOCATION_NEEDS_REVIEW
    )
);

export const selectCompanyRedFlagsLoading = createSelector(
  selectCompanyRedFlagsState,
  (state) => state.loading
);
